import { useState } from 'react';
import { supabase } from '../utils/supabaseClient';
import { useAuth } from '../contexts/AuthContext';
import { ReactComponent as OpteraLogo } from '../optera_Logo.svg';

function ResetPassword() {
    const { setPasswordRecovery } = useAuth();
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (password !== confirm) {
            setError('Passwörter stimmen nicht überein.');
            return;
        }
        if (password.length < 6) {
            setError('Passwort muss mindestens 6 Zeichen lang sein.');
            return;
        }
        setLoading(true);
        const { error } = await supabase.auth.updateUser({ password });
        if (error) {
            setError(error.message);
        } else {
            setDone(true);
            setTimeout(() => setPasswordRecovery(false), 2000);
        }
        setLoading(false);
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-base-200">
            <div className="w-full max-w-sm rounded-xl bg-base-100 p-8 shadow-xl">
                <div className="mb-6 text-center flex flex-col items-center">
                    <OpteraLogo className="h-10 w-auto mb-2" style={{ color: '#7B5EA7' }} />
                    <p className="text-sm font-medium text-base-content/70">Neues Passwort festlegen</p>
                </div>

                {done ? (
                    <p className="text-center text-sm text-green-600 font-medium">
                        Passwort erfolgreich geändert. Du wirst weitergeleitet…
                    </p>
                ) : (
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="mb-1 block text-sm font-medium text-base-content/80">
                                Neues Passwort
                            </label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                autoFocus
                                className="w-full rounded-lg border border-base-300 bg-base-100 px-3 py-2 text-sm text-base-content outline-none focus:border-primary focus:ring-1 focus:ring-primary"
                            />
                        </div>
                        <div>
                            <label className="mb-1 block text-sm font-medium text-base-content/80">
                                Passwort bestätigen
                            </label>
                            <input
                                type="password"
                                value={confirm}
                                onChange={(e) => setConfirm(e.target.value)}
                                required
                                className="w-full rounded-lg border border-base-300 bg-base-100 px-3 py-2 text-sm text-base-content outline-none focus:border-primary focus:ring-1 focus:ring-primary"
                            />
                        </div>

                        {error && <p className="text-sm text-red-500">{error}</p>}

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-content transition hover:opacity-90 disabled:opacity-50"
                        >
                            {loading ? 'Wird gespeichert…' : 'Passwort speichern'}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}

export default ResetPassword;
